/**
 * The bonuses listed on /profile/free-bonus.
 *
 * Single source of truth: the menu renders one tile per entry, the route
 * validates ?tab= against it, and the page switches on the union — so a new
 * bonus is added here and wired in the page alone.
 *
 * Kept out of the route module so the menu component does not pull the router
 * tree in behind it. `friday-pay`, `monthly-bonus`, `free-play` and
 * `birthday-gift` are all deliberately absent — each was retired with its page,
 * leaving the rescue bonus as the only one still offered.
 */
export const FREE_BONUS_TABS = ['rescue-bonus'] as const

export type FreeBonusTab = (typeof FREE_BONUS_TABS)[number]

export const isFreeBonusTab = (value: unknown): value is FreeBonusTab =>
  FREE_BONUS_TABS.includes(value as FreeBonusTab)
